export interface ListGridScroll {
  xAxis?: string;
  yAxis?: string;
}
